import { CommentType } from '@/types/Content/Comment';
import * as Sentry from '@sentry/nextjs';
import { cmsProxyApi } from './cmsProxyApi';

interface ServiceResponse<T> {
  data: T;
  error: unknown;
}

interface CommentParams {
  content_id: string;
  user_id: string | number;
  body: string;
}

const commentService = {
  async create(params: CommentParams): Promise<ServiceResponse<any>> {
    try {
      const response = await cmsProxyApi.post(`/comments`, params);

      return { data: response?.data, error: null };
    } catch (error) {
      Sentry.captureException(error);

      return { data: null, error };
    }
  },
  async createReply(
    data: { text: string },
    { commentId, contentId }: { commentId: string; contentId: string },
  ): Promise<ServiceResponse<any>> {
    try {
      const response = await cmsProxyApi.post(
        `/comments/${commentId}/content/${contentId}/reply`,
        data,
      );

      return { data: response?.data, error: null };
    } catch (error) {
      Sentry.captureException(error);

      return { data: null, error };
    }
  },

  async remove(
    comment: CommentType,
    contentId: string,
  ): Promise<ServiceResponse<any>> {
    try {
      const response = await cmsProxyApi.delete(
        `/comments/${comment.id}/content/${contentId}`,
      );

      return { data: response?.data, error: null };
    } catch (error) {
      Sentry.captureException(error);

      return { data: null, error };
    }
  },
  async removeReply(
    reply: CommentType,
    contentId: string,
    commentId: string,
  ): Promise<ServiceResponse<any>> {
    try {
      const response = await cmsProxyApi.delete(
        `/comments/${commentId}/content/${contentId}/reply/${reply.id}`,
      );

      return { data: response?.data, error: null };
    } catch (error) {
      Sentry.captureException(error);

      return { data: null, error };
    }
  },
};

export default commentService;
